/**
 * OFF do agrupamento: 1 grupo por item, key = id da conversa — o render fica
 * idêntico ao histórico (mesmas keys, mesma ordem, mesmo card por item).
 */
export function toSingletonGroups(items) {
    return items.map((item) => ({
        key: item.id,
        personId: item.personId,
        person: item.person,
        items: [item],
    }));
}
export function groupByPerson(items) {
    const groups = [];
    const byPerson = new Map();
    for (const item of items) {
        if (item.personId === null) {
            groups.push({ key: item.id, personId: null, person: item.person, items: [item] });
            continue;
        }
        const existing = byPerson.get(item.personId);
        if (existing === undefined) {
            const group = {
                key: item.personId,
                personId: item.personId,
                person: item.person,
                items: [item],
            };
            byPerson.set(item.personId, group);
            groups.push(group);
        }
        else {
            existing.items.push(item);
            // Ref expandido pode faltar em itens individuais (classe «vínculo mudo») —
            // o grupo fica com o primeiro ref não-nulo que aparecer.
            if (existing.person === null && item.person !== null)
                existing.person = item.person;
        }
    }
    return groups;
}
//# sourceMappingURL=group-by-person.js.map